import React from 'react';
import { useNavigate } from 'react-router-dom';
import AppBrand from '../components/AppBrand';

function PrivacyPage({ theme = 'dark' }) {
  const navigate = useNavigate();
  const darkMode = theme === 'dark';

  return (
    <div className={`legal-page-shell ${darkMode ? 'dark' : 'light'}`}>
      <div className="legal-page-container">
        <AppBrand theme={theme} />
        <div className="legal-page-topbar">
          <button
            type="button"
            className="back-link-btn"
            onClick={() => navigate('/')}
          >
            ← Back to App
          </button>
        </div>

        <div className="legal-page-card">
          <div className="legal-page-badge">Legal</div>
          <h1 className="legal-page-title">Privacy Policy</h1>

          <section className="legal-section">
            <h2>1. Overview</h2>
            <p>
              This Privacy Policy explains what information StockVested collects,
              how we use it, and the choices available to you.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Information We Collect</h2>
            <p>We may collect information such as:</p>
            <ul>
              <li>account details such as name, email, and login information</li>
              <li>subscription and billing-related information</li>
              <li>trade journal content, notes, and app usage history</li>
              <li>device, browser, session, and diagnostic information</li>
              <li>support messages and feedback you provide to us</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>3. How We Use Information</h2>
            <p>We may use personal information to:</p>
            <ul>
              <li>provide and maintain the platform</li>
              <li>authenticate users and secure accounts</li>
              <li>process subscriptions and manage billing</li>
              <li>improve features, reliability, and performance</li>
              <li>respond to support inquiries and service issues</li>
              <li>communicate important account, service, or policy updates</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>4. Payment Processing</h2>
            <p>
              Payments are processed by third-party payment providers such as Stripe.
              We do not store full payment card details on our own servers unless
              expressly stated otherwise.
            </p>
          </section>

          <section className="legal-section">
            <h2>5. Service Providers</h2>
            <p>
              We may use third-party providers for hosting, authentication, analytics,
              databases, infrastructure, customer support, and payment processing.
              Those providers may process information on our behalf as needed to
              operate the service.
            </p>
          </section>

          <section className="legal-section">
            <h2>6. Data Retention</h2>
            <p>
              We retain information for as long as reasonably necessary to provide the
              service, comply with legal obligations, resolve disputes, and enforce
              agreements.
            </p>
          </section>

          <section className="legal-section">
            <h2>7. Your Choices</h2>
            <p>
              Depending on your location and applicable law, you may have rights to
              access, correct, delete, or request information about personal data we
              hold about you. You may also close your account, subject to legal and
              operational retention requirements.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Security</h2>
            <p>
              We use reasonable administrative, technical, and organizational measures
              to protect information. However, no security method is perfect, and we
              cannot guarantee absolute security.
            </p>
          </section>

          <section className="legal-section">
            <h2>9. Children</h2>
            <p>
              The service is not directed to children. Do not use the service if you
              are not legally permitted to do so in your jurisdiction.
            </p>
          </section>

          <section className="legal-section">
            <h2>10. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. Updated versions
              become effective when posted unless otherwise stated.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPage;